import { FormattedRates } from '../constants';

export const getEtikaCreditLine = (rates: FormattedRates | []): number => {
  const etikaRates = Object.values(rates)
    .flat()
    .filter((rate) => rate.enabled && rate.provider === 'etika')
    .map((rate) => rate.creditLine || 0);

  return Math.max(...etikaRates);
};
